/**
 * One-time cookie that signals "a real, verified new signup just completed"
 * to the browser so it can fire the Meta Pixel + Google Ads signup conversion
 * events.
 *
 * Set server-side at the verified-new-signup moment (the OAuth callback for
 * social signups, the email-confirmation handler for password signups) and
 * read + cleared exactly once on the next page load by SignupConversionTracker.
 * Firing client-side keeps it consistent across every signup method and avoids
 * counting unverified / abandoned signups.
 *
 * Pure constants only — safe to import from both server and client code.
 */
export const SIGNUP_CONVERSION_COOKIE = 'signup_conversion';

// 5 minutes — only needs to survive the post-auth redirect to the next page.
export const SIGNUP_CONVERSION_COOKIE_MAX_AGE = 300;
